import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './MentionList.css';

export default forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = index => {
    const item = props.items[index];
    if (item) {
      // Tiptap mention extension by default expects id and label
      props.command({ id: item });
    }
  };

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }
      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }
      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }
      return false;
    },
  }));

  if (!props.items || props.items.length === 0) {
    return null;
  }

  return (
    <div className="mention-list">
      {props.items.map((item, index) => (
        <button
          className={`mention-item ${index === selectedIndex ? 'is-selected' : ''}`}
          key={index}
          onClick={() => selectItem(index)}
        >
          <img 
            src={`https://images.hive.blog/u/${item}/avatar/small`} 
            alt={item} 
            className="mention-avatar" 
            onError={(e) => { e.target.src = 'https://images.hive.blog/u/hiveio/avatar/small'; }}
          />
          <span className="mention-name">{item}</span>
        </button>
      ))}
    </div>
  );
});
